<template>
<div class="form">
  <v-card style="margin-top: 250px">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <h1 align="center" style="text-decoration: underline overline;">FOOD WASTE</h1>

      <v-text-field
        outlined 
        dense
        rounded
        v-model="HID"
        label="HID"
        width="20px"
        disabled
      ></v-text-field>

    <!-- DATATABLE-->
    <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
          <v-card-title>
              Senarai
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

            <v-spacer></v-spacer>
              <v-btn
              color="error"
              small
              @click="dialogPengesahan=true;"
              >
                Padam
            </v-btn>

          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="datafoodwaste"
            :search="search"
            class="ml-3 mr-3"
            @click:row="handleClick"
            :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
          ></v-data-table>
    </v-card>   
  </v-card> 

  <v-card><br>&nbsp;&nbsp;&nbsp;
      <span style="color:red;font-weight:bold;font-size: small;"> Medan yang bertanda * wajib diisi</span>
    <v-card-title>
      FOOD WASTE
  </v-card-title>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
    > 
    <v-card-text>
     <!-- <div> -->
         <v-row>
            <!-- * Sekiranya S2 adalah Ketua isi rumah -->
            <v-col class="black--text">
              S7. Sila nyatakan anggaran kuantiti sisa makanan yang dibuang oleh Isi Rumah dalam gram pada minggu rujukan (minggu pertama bulan rujukan). 
              <strong>[KSM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              </v-col> </v-row>

              <v-row>
                <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="KSM"
                label="g"
                type="number"
                required
                @keypress="limitDigits3"
                min="0"
                :rules="schemeRule.required"
              ></v-text-field> 
            </v-col>  
            
            <v-col class="mt-4 text-subtitle-2">
              gram/minggu
              </v-col>
            </v-row>
     
          <v-row>
            <v-col class="black--text">
          S8. Berdasarkan kuantiti sisa makanan yang dilaporkan pada soalan S.7, Sila nyatakan punca utama buangan makanan berkenaan. [Tidak lebih dari 3 pilihan utama]	<br /> </v-col>                
          </v-row>
          
          <v-row><br />
            <v-col class="black--text">
          Kod punca utama kepada pembaziran makanan  <strong>[PBM]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span> 
          </v-col> </v-row>
          <v-container class="black--text">
             <v-row>
              <v-col cols="4" sm="6" md="4">
                (i)<strong>[PBM1]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="PuncaPembaziran"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="PBM1"
              :rules="schemeRule.required"
              @change="S8_PBM1()"
            ></v-autocomplete>           
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii)<strong>[PBM2]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="PuncaPembaziran"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="PBM2"
              :rules="schemeRule.required"
              @change="S8_PBM2()"
              ></v-autocomplete>           
              </v-col>
              
              <v-col cols="4" sm="6" md="4"> 
                (iii)<strong>[PBM3]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
              <v-autocomplete
              :items="PuncaPembaziran"
              :item-text="item => item.id + ' - ' + item.desc"
              label=""
              return-object
              required
              solo
              outlined
              dense
              style="width: 350px"
              v-model="PBM3"
              :rules="schemeRule.required"
              @change="S8_PBM3()"
              ></v-autocomplete> 
              </v-col>  
         </v-row>
        </v-container>
              
  <!-- pilihan PBM adalah 3 -->
   <v-col v-show="showS8A" class="black--text">
          <v-row>
              S8.9 . Sila nyatakan cara anda melupuskan melupuskan sisa pepejal
              di tempat kediaman anda<strong>[PBMLain]</strong><br />
          </v-row>
          <!-- <v-container> -->
            <v-row>
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="PBMlain"
                  persistent-hint
                  label="0"
                  outlined
                  solo
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
    </v-col>

    <v-col v-show="showS8B" class="black--text">
          <v-row>
              S8.9 . Sila nyatakan cara anda melupuskan melupuskan sisa pepejal
              di tempat kediaman anda<strong>[PBMLain]</strong><br />
          </v-row>
          <!-- <v-container> -->
            <v-row>
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="PBMlain"
                  persistent-hint
                  label="0"
                  outlined
                  solo
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
          <!-- </v-container> -->
    </v-col>

    <v-col v-show="showS8C" class="black--text">
          <v-row>
              S8.9 . Sila nyatakan cara anda melupuskan melupuskan sisa pepejal
              di tempat kediaman anda<strong>[PBMLain]</strong><br />
          </v-row>
          <!-- <v-container> -->
            <v-row>
              <v-col cols="6" sm="6" md="4">
                <v-text-field
                  v-model="PBMlain"
                  persistent-hint
                  label="0"
                  outlined
                  solo
                  dense
                  style="width: 350px"
                ></v-text-field>
              </v-col>
            </v-row>
    </v-col>

  </v-card-text>
</v-form>
 
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
          text
          color="primary"
          @click="simpan()"
          v-show="butangSimpan"
         :disabled="!KSM || !PBM1 || !PBM2 || !PBM3"  
        >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="!PBM1 || updatefoodwaste()" 
      :disabled="!KSM "
      
    >
      Kemaskini
    </v-btn>
    
</v-card-actions>
</v-card>


  <!-- Error Dialog -->
  <v-dialog
        v-model="errorDialog"
        width="500"
        height="200"
      >
      <v-card>
        <v-alert
          dense
          outlined
          color="#C51162"
          type="error"
        >
        <strong>{{errMessage}}</strong>
        </v-alert>
      </v-card>
  </v-dialog>
  
  <!-- Success Dialog -->
  <v-dialog
        v-model="successDialog"
        max-width="800"
        height="200"
      >
      <v-card
        color="success"
      >
        <v-alert
          dense
          outlined
          color="#C51162"
          type="success"
        >
        <strong>{{successMessage}}</strong>
        </v-alert>
  
        <v-card-actions> 
          <v-spacer></v-spacer>
              <v-btn
                  color="warning"
                  @click='successDialog = false;goTo("1");'
              >
                Batal
              </v-btn>
              <v-btn
                  color="pink"
                  v-show="butangKemaskini"
                  @click='successDialog = false;'
              >
                Kemaskini
              </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>

 <!-- Pengesahan Padam Dialog -->

 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <strong>{{$t(" HID: "+this.HID)}}</strong> 
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row> 

</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    // props:['data'],
    async beforeMount(){
        //this.getUnits('ayam')
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        this.PuncaPembaziran = lookupFieldServices.getPuncaPembaziran();
        
        
        this.getData();//dapatkan data based on HID


    },
    setup() {
        
    },
    data: () => ({
        butangSimpan: true,
        butangKemaskini: false,

        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        kemaskiniDialog: false,
        dialogPengesahan:false,
        PuncaPembaziran:[],
      
        /////////////////////data declaration//////////////////////////
        HID :'',
        KSM :'',
        PBM1:'',
        PBM2:'',
        PBM3:'',
        PBMlain:'',
        datafoodwaste:[],

        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'HID', value: 'HID' },
          { text: 'KSM', value: 'KSM' },
          { text: 'PBM1', value: 'PBM1' },
          { text: 'PBM2', value: 'PBM2' },
          { text: 'PBM3', value: 'PBM3' },
          { text: 'PBMlain', value: 'PBMlain' },
         
        ],
       //////////link untuk ke page/////////////////////
       breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'Food Waste',
          disabled: true,
          href: 'foodwaste',
        },
      ],
        
    }),

 
methods: {
    limitDigits3(event) {
        const value = event.target.value;
        if (value.length >= 5) {
            event.preventDefault();
        }
      },
    S8_PBM1(){
        if ( this.PBM1.id!=0 && this.PBM1.id == this.PBM3.id || this.PBM1.id == this.PBM2.id ){
        this.PBM1 = { id: 0 };
        }
        if ( this.PBM1.id==0 ){
        //this.PBM1 = null;
        this.PBM1 = {"id":"0","disabled":true};
       }
      },

      S8_PBM2(){
        if(this.PBM2.id!=0 && this.PBM2.id == this.PBM1.id ){
        this.PBM2 = { id: 0 };
        }
        if(this.PBM2.id!=0 &&  this.PBM2.id == this.PBM3.id){
        this.PBM2 = { id: 0 };
        }
      },
      
      S8_PBM3(){
  
        if(this.PBM3.id!=0 && this.PBM3.id == this.PBM2.id){
        this.PBM3 = { id: 0 };
        }
        if(this.PBM3.id!=0 && this.PBM3.id == this.PBM1.id){
        this.PBM3 = { id: 0 };
        }
      },

  validate () {
    this.$refs.form.validate();
  },
  
  reset () {
    this.$refs.form.reset();
  },

  resetValidation () {
    this.$refs.form.resetValidation();
    
  },

async simpan (){

  await this.semakan();
        
        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
      
            try {
        

            const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/insertfoodwaste`, {
            
            HID:  this.HID,
            NOAIR: this.NOAIR,
            KSM: this.KSM,
            PBM1: this.PBM1.id,
            PBM2: this.PBM2.id,
            PBM3: this.PBM3.id,
            PBMlain: this.PBMlain,

          })
                          this.res = res.data
                          this.successMessage = 'Data Disimpan!';
                          this.getData();
                          this.successDialog = true;
                          setTimeout(() => (this.successDialog = false), 2000);
                          this.reset();                
                          window.scrollTo(0, 0);
                          //setTimeout(() => (this.goTo()), 1000);
                          
                      } catch (error) {
                        //console.log(error)
                        this.errorDialog = true;
                        setTimeout(() => (this.errorDialog = false), 2000);
                        //this.errMessage = 'Simpan : '+error;
                        //this.errMessage = 'Sila semak pengisian!';
                        this.errMessage = 'Berjaya disimpan!';
                      }
                  }else{
                      window.scrollTo(0, 0);
                      this.errorDialog = true;
                      setTimeout(() => (this.errorDialog = false), 2000);
                      //this.errMessage = 'Please fill in the field!';
                      this.errMessage = 'Sila semak pengisian!';
                  }
      },
  async updatefoodwaste() {
      await this.semakan2();  
        this.dialog =  true;
        setTimeout(() => (this.dialog = false), 2000)
      
        try {
            const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updatefoodwaste`, {
            HID:  this.HID,
            NOAIR: this.NOAIR,
            KSM: this.KSM,
            PBM1: this.PBM1.id,
            PBM2: this.PBM2.id,
            PBM3: this.PBM3.id,
            PBMlain: this.PBMlain,

          })
          this.res = res.data;
          this.reset();
          this.getData();
          this.butangKemaskini = false;
          this.successMessage = 'Data Dikemaskini!';
          this.successDialog = true;
          window.scrollTo(0, 0);
          //setTimeout(() => (this.goTo()), 1000);
          } catch (error) {
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = 'Sila semak pengisian!';
        }
  },
  async padam(val){
    if(val == 0){
     this.popUpALert = true; 
   }
   else if(val == 1){
      
      try {
          ///////////tunjukkan alert padam////////////
         this.popUpALert = false;
            ////send delete to API///////
         if (this.$refs.form.validate()){
           const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/deletefoodwaste`, {
            HID:  this.HID,
            NOAIR: this.NOAIR,
         })
            this.res = res.data
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = 'Data Deleted!'
            this.saveButton = false;
            this.updateButton = true;
            this.reset();
            this.getData(); 
         }
       } 
        
        catch (error) {
         console.log(error)
         this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
         this.errMessage = 'Padam : '+error;
        }
   }
    else if(val == 2){
      this.popUpALert = false;
   }
      
 },
  async padamData(){

       try {
               const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/deletefoodwaste`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "HK7"
             })
             this.res = res.data
            this.successMessage = 'Data Dipadam!';
            this.getData();
            this.successDialog = true;
            this.dialogPengesahan = false;
            setTimeout(() => (this.successDialog = false), 2000);
            this.reset();                
            window.scrollTo(0, 0);
            //setTimeout(() => (this.goTo()), 1000);
                          
              
            } catch (error) {
              //console.log(error)
             this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },
  async getData(){
        //dapatkan data dari table HK1 based on HID
   
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/getfoodwaste?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            var dataz = res.data.data
            this.datafoodwaste = dataz;
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
  },
  async handleClick(row) {
   
            this.butangKemaskini = true;
            this.successMessage = 'Data Pengisian Dipilih, Nyatakan pilihan anda!';
            this.successDialog = true;

          this.butangSimpan = false;
          this.butangKemaskini = true;

          this.NOAIR = row.NOAIR;
          this.HID = row.HID;
          this.KSM = row.KSM;
          this.PBMlain = row.PBMlain;
        
          
          if(row.PBM1 != 9 && row.PBM2 != 9 && row.PBM3 != 9){
            this.PBMlain = "-";}

          if(row.PBM1 == 1){
            this.PBM1 = this.PuncaPembaziran[0];
          }
          if(row.PBM1 == 2){
            this.PBM1 = this.PuncaPembaziran[1];
          }
          if(row.PBM1 == 3){
            this.PBM1 = this.PuncaPembaziran[2];
          }
          if(row.PBM1== 4){
            this.PBM1 = this.PuncaPembaziran[3];
          }
           if(row.PBM1 == 5){
            this.PBM1= this.PuncaPembaziran[4];
          }
           if(row.PBM1 == 6){
            this.PBM1= this.PuncaPembaziran[5];
          }
          if(row.PBM1== 7){
            this.PBM1 = this.PuncaPembaziran[6];
          }
          if(row.PBM1 == 8){
            this.PBM1= this.PuncaPembaziran[7];
          }
          if(row.PBM1 == 9){
            this.PBM1= this.PuncaPembaziran[8];
          }
         // if(row.PBM1 == 0){
            //this.PBM1= this.PuncaPembaziran[9];
        //  }

          if(row.PBM2 == 1){
            this.PBM2 = this.PuncaPembaziran[0];
          }
          if(row.PBM2 == 2){
            this.PBM2 = this.PuncaPembaziran[1];
          }
          if(row.PBM2 == 3){
            this.PBM2 = this.PuncaPembaziran[2];
          }
          if(row.PBM2== 4){
            this.PBM2 = this.PuncaPembaziran[3];
          }
           if(row.PBM2 == 5){
            this.PBM2= this.PuncaPembaziran[4];
          }
           if(row.PBM2 == 6){
            this.PBM2= this.PuncaPembaziran[5];
          }
          if(row.PBM2== 7){
            this.PBM2 = this.PuncaPembaziran[6];
          }
          if(row.PBM2 == 8){
            this.PBM2= this.PuncaPembaziran[7];
          }
          if(row.PBM2 == 9){
            this.PBM2= this.PuncaPembaziran[8];
          }
          if(row.PBM2 == 0){
            this.PBM2= this.PuncaPembaziran[9];
          }

          if(row.PBM3 == 1){
            this.PBM3 = this.PuncaPembaziran[0];
          }
          if(row.PBM3 == 2){
            this.PBM3 = this.PuncaPembaziran[1];
          }
          if(row.PBM3 == 3){
            this.PBM3 = this.PuncaPembaziran[2];
          }
          if(row.PBM3== 4){
            this.PBM3 = this.PuncaPembaziran[3];
          }
           if(row.PBM3 == 5){
            this.PBM3= this.PuncaPembaziran[4];
          }
           if(row.PBM3 == 6){
            this.PBM3= this.PuncaPembaziran[5];
          }
          if(row.PBM3== 7){
            this.PBM3 = this.PuncaPembaziran[6];
          }
          if(row.PBM3 == 8){
            this.PBM3 = this.PuncaPembaziran[7];
          }
          if(row.PBM3 == 9){
            this.PBM3 = this.PuncaPembaziran[8];
          }
          if(row.PBM3 == 0){
            this.PBM3= this.PuncaPembaziran[9];
          }

         
  },
  
//check pilihan PBM lain//
semakan(){
  if(this.PBM1.id != 9 && this.PBM2.id != 9 && this.PBM3.id != 9){
            this.PBMlain = "-";
          }
          if(this.PBM1.id == 0 || this.PBM1 == 0||this.PBM1 == null){
            this.PBM1 = null;
          }
},
semakan2(){
  if(this.PBM1.id != 9 && this.PBM2.id != 9 && this.PBM3.id != 9){
            this.PBMlain = "-";
          }
          if(this.PBM1.id == 0 || this.PBM1 == 0||this.PBM1 == null){
            this.PBM1 = null;
          }
          
},
},

//check pilihan PBM lain//
watch:{

  PBM1(val){
    
    if(val.id == 9){
      this.showS8A = true; 
    }
    else{
      this.showS8A = false;
     
    }
   },

  PBM2(val){
    
    if(val.id == 9){
      this.showS8B = true;
    }
    else{
      this.showS8B = false;
      
    }
   },

PBM3(val){
    
         if(val.id == 9){
           this.showS8C = true;
         }
         else{
           this.showS8C= false;
          
         }
        },
   

    datafoodwaste(){
      if(this.datafoodwaste.length > 0) // && this.Jumlah == 100)//
      {
        this.butangSimpan = false;
      }
    }
  },
  
  computed: {
 /* Jumlah: function(){
    var total = 0;
    total = total + Number(this.RF1Peratus) + Number(this.RF2Peratus) + Number(this.RF3Peratus) + Number(this.RF4Peratus) + Number(this.RF5Peratus)
     + Number(this.RF6Peratus) + Number(this.RF7Peratus) + Number(this.PF1Peratus) + Number(this.PF2Peratus) + Number(this.PF3Peratus)
     + Number(this.FAHPeratus);
    total =  total.toFixed(2) 

    return total;
  },
  isJumlahValid() {

    return this.Jumlah == 100;
  }, */


  schemeRule() {
      return schemeRule;
    }
}
    
}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
  
}

</style>